import useSetExport from '@components/export/useSetExport';
import { useMemo } from 'react';

// related events table widget
function useSetManualAlertAllEventsExport({ columns, alert }) {

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'alerts-panel',
    widgetKey: 'manual-alert-all-events',
    widgetInfo: alert ? { title: `All Events of ${alert.name}` } : {},
    data: alert ? alert.events : [],
    headers: columns,
  });

}

export default useSetManualAlertAllEventsExport;
